/** @jsxImportSource @emotion/react */
import { getMemberEmailList, getOrganizationUnitList } from "apis/google";
import { google } from "googleapis";


//* INFO: GWS 내 멤버 이메일 리스트 가져오기
export const openGooglePopup = (
  shouldFetchRefreshToken?: boolean,
  callback?: (success: boolean, email: string[], googleRefreshToken: string, message?: string) => void
) => {
  const refreshTokenParam = shouldFetchRefreshToken ? "&prompt=consent" : "&prompt=select_account";
  const scopes = ["https://www.googleapis.com/auth/admin.directory.user"];
  const url = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_WEB_URL}/google/redirect/member-list&scope=${scopes.join(
    " "
  )}&access_type=offline${refreshTokenParam}`;

  const popup = window.open(url, "member-list", "width=600,height=800");

  const handleMessage = async (event: MessageEvent) => {
    const { googleAccessToken, googleRefreshToken } = event.data;

    if (googleAccessToken) {
      const res = await getMemberEmailList(googleAccessToken);
      if (res.success) {
        callback?.(res.success, res?.email ?? [], googleRefreshToken);
      } else {
        callback?.(res.success, [], googleRefreshToken, res?.message);
      }
    }
  };
  const timer = setInterval(() => {
    try {
      if (popup?.closed) {
        clearInterval(timer);
        window.removeEventListener("message", handleMessage);
      }
    } catch (error) {
      console.error("Error detecting popup closed", error);
    }
  }, 1000);

  window.addEventListener("message", handleMessage);
};


//* INFO: GWS 내 Organization Unit 리스트 가져오기
export const openGoogleOrgUnitPopup = (
  callback?: (success: boolean, googleAccessToken: string, googleRefreshToken: string) => void,
) => {
  const refreshTokenParam = "&prompt=consent";
  const scopes = [
    "https://www.googleapis.com/auth/admin.directory.orgunit.readonly",
    "https://www.googleapis.com/auth/admin.directory.user",
  ];
  const url = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_WEB_URL}/google/redirect/member-list&scope=${scopes.join(
    " "
  )}&access_type=offline${refreshTokenParam}`;

  const popup = window.open(url, "org-unit", "width=600,height=800");
  let messageReceived = false;

  const handleMessage = async (event: MessageEvent) => {
    const { googleAccessToken, googleRefreshToken } = event.data;
    if (googleAccessToken) {
      messageReceived = true;
      callback?.(true, googleAccessToken, googleRefreshToken);
    }
  };

  const timer = setInterval(() => {
    try {
      if (popup?.closed) {
        clearInterval(timer);
        window.removeEventListener("message", handleMessage);

        if (!messageReceived) {
          callback?.(false, "", "");
        }
      }
    } catch (error) {
      console.error("Error detecting popup closed", error);
    }
  }, 1000);

  window.addEventListener("message", handleMessage);
};
